/*
 * An interceptor to trim all POST/PUT request body values.
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2025 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable ()
export class TrimInterceptor implements HttpInterceptor {

  intercept ( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
    // Check for custom header to bypass trimming
    if ( req.headers.has ( 'X-Bypass-Trim' ) ) {
      // Remove the bypass header before passing the request along
      const cleanReq = req.clone ( { headers: req.headers.delete ( 'X-Bypass-Trim' ) } );
      return next.handle ( cleanReq );
    }

    if ( ( req.method === 'POST' || req.method === 'PUT' ) && req.body && typeof req.body === 'object' ) {
      const trimmedBody = this.trimValues ( req.body );
      const clonedRequest = req.clone ( { body: trimmedBody } );
      return next.handle ( clonedRequest );
    }
    return next.handle ( req );
  }

  private trimValues ( obj: any ): any {
    if ( Array.isArray ( obj ) ) {
      return obj.map ( value => ( typeof value === 'string' ? value.trim () : this.trimValues ( value ) ) );
    } else if ( typeof obj === 'object' && obj !== null ) {
      return Object.fromEntries (
        Object.entries ( obj ).map ( ( [ key, value ] ) =>
          [ key, typeof value === 'string' ? value.trim () : this.trimValues ( value ) ],
        ),
      );
    }
    return obj;
  }
}

